// Only keys consumed by CargaSCL and present in the debtor information mapping.
// The import mapping itself remains complete regardless of visibility settings.
export const SCL_DEBTOR_FIELDS = {
    'generalInformation:id_cliente': 'CLIENTE_UNICO',
    'generalInformation:nombre': 'NOMBRE_CTE',
    'generalInformation:edad': 'EDAD_CLIENTE',
    'generalInformation:cartera': 'CARTERA',
    'generalInformation:producto': 'PRODUCTO',
    'generalInformation:estatus_plan': 'ESTATUS_PROMESA_PAGO',
    'generalInformation:rmd': 'RMD',
    'generalInformation:territorio': 'TERRITORIO',
    'generalInformation:zona': 'ZONA',
    'generalInformation:gerencia': 'GERENCIA',
    'paymentInformation:total': 'SALDO_TOTAL',
    'paymentInformation:dia_de_pago': 'FIDIAPAGO',
    'paymentInformation:atraso_max': 'ATRASO_MAXIMO',
    'paymentInformation:moratorios': 'MORATORIOS',
    'paymentInformation:fecha_pago_ultimo': 'FECHA_ULTIMO_PAGO',
    'paymentInformation:id_grupo': 'ID GRUPO',
    'paymentInformation:saldo': 'SALDO',
    'paymentInformation:importe_pago_ultimo': 'IMP_ULTIMO_PAGO',
    'paymentInformation:nombre_grupo': 'GRUPO_MAZ',
    'paymentInformation:campania': 'CAMPANIA',
    'paymentInformation:fecha_asignacion': 'FECHA_ASIGNACION',
    'paymentInformation:dias_asignacion': 'DIAS_ASIGNACION',
    'directionInformation:direccion': 'DIRECCION_CTE',
    'directionInformation:num_ext': 'NUM_EXT_CTE',
    'directionInformation:num_int': 'NUM_INT_CTE',
    'directionInformation:colonia': 'COLONIA_CTE',
    'directionInformation:poblacion': 'POBLACION_CTE',
    'directionInformation:estado': 'ESTADO_CTE',
    'directionInformation:cp': 'CP_CTE',
    'directionInformation:referencia_domicilio': 'REFERENCIAS_DOMICILIO',
    'trabajoInformation:direccion': 'CALLE_EMPLEO',
    'trabajoInformation:num_ext': 'NUM_EXT_EMPLEO',
    'trabajoInformation:num_int': 'NUM_INT_EMPLEO',
    'trabajoInformation:colonia': 'COLONIA_EMPLEO',
    'trabajoInformation:poblacion': 'POBLACION_EMPLEO',
    'trabajoInformation:estado': 'ESTADO_EMPLEO',
    'avalInformation:nombre_aval': 'NOMBRE_AVAL',
    'avalInformation:direccion': 'CALLE_AVAL',
    'avalInformation:num_ext': 'NUM_EXT_AVAL',
    'avalInformation:colonia': 'COLONIA_AVAL',
    'avalInformation:poblacion': 'POBLACION_AVAL',
    'avalInformation:estado': 'ESTADO_AVAL',
    'avalInformation:cp': 'CP_AVAL',
    'avalInformation:numero_tel': 'TEL_AVAL',
};

export const SCL_SECTIONS = [
    { key: 'general', group: 'generalInformation' },
    { key: 'credito', group: 'paymentInformation' },
    { key: 'domicilios', group: 'directionInformation' },
    { key: 'trabajos', group: 'trabajoInformation' },
    { key: 'avales', group: 'avalInformation' },
];
